import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import cn from 'classnames';
import ProductCarousel from 'components/Common/ProductCarousel/ProductCarousel';
import { useLandingPageContext } from 'context/LandingPageContext';
import React, { FC, useEffect, useState } from 'react';
import { Recommendation } from 'store/landing/slice';
import gtmBlueshiftRecommendationEvent from 'utils/gtm/gtmBlueshiftRecommendationEvent';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import { ProductItemPreview } from 'components/Common';
import styles from './RecommendationsBlock.module.scss';

export interface RecommendationsProps {
  categoryId: number;
  slotName: string;
  title: string;
  subCategoryId?: number;
}

const RecommendationsBlock: FC<RecommendationsProps> = ({ categoryId, slotName, title, subCategoryId }) => {
  const { theme, isDesktopDevice, locale, landingPageId } = useLandingPageContext();
  const [recommendations, setRecommendations] = useState<Recommendation[]>([]);
  const fetchRecommendations = () =>
    apiRequest<Recommendation[]>(
      endpoints.recommendationV2List,
      {
        isMobile: !isDesktopDevice,
        categoryId,
        locale,
        encDesignId: '',
        slotName,
        subCategoryId,
        limit: 20,
      },
      HttpMethods.POST,
      'data.items',
    );

  const trackBlueshiftRecommendation = (product: Recommendation) => {
    gtmSendEvent(gtmBlueshiftRecommendationEvent(product, 'landing', undefined, landingPageId));
  };

  useEffect(() => {
    let mounted = true;
    fetchRecommendations().then((data) => {
      if (mounted) {
        setRecommendations(data);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className={cn(styles.container, styles[`theme-${theme}`])}>
      <ProductCarousel progressBar arrowType="filled" theme={theme} title={title}>
        {recommendations.map((recommendation, index) => (
          <ProductItemPreview
            key={`${recommendation.productId} + ${index}`}
            showPrice
            usePriceFromProps
            productId={recommendation.productId}
            categoryId={recommendation.categoryId}
            productName={recommendation.name || ''}
            productThumbnail={recommendation.thumbnail}
            productUrl={recommendation.url || ''}
            theme={theme}
            initialPrice={recommendation.initialPrice?.value}
            initialPriceFormatted={recommendation.initialPrice?.formatted}
            finalPrice={recommendation.finalPrice?.value}
            finalPriceFormatted={recommendation.finalPrice?.formatted}
            onClick={() => trackBlueshiftRecommendation(recommendation)}
          />
        ))}
      </ProductCarousel>
    </div>
  );
};

export default RecommendationsBlock;
